import { Helmet } from "react-helmet";
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    Avatar,
    Divider,
    Grid,
    Paper,
} from "@mui/material";
// import {useTranslation} from "react-i18next";
import { makeStyles } from "@mui/styles";
import Upload from "../../components/UploadImages";
import React, { useState } from "react";
import { ReactComponent as TrashIcon } from "../../assets/images/portfolio/trash-alt.svg";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    customAvatarColor: {
        color: "red",
    },
    cardContentHeaderSize: {
        display: "flex",
    },
    cardContentSize: {
        display: "flex",
        justifyContent: "center",
        // flexFlow: "row",
        alignItems: "center",
        height: "calc(100% - 130px)",
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap"
    },
    customCardSize: {
        height: 380,
    },
    titleColor: {
        color: "#B5B5B5"
    },
    subTitleColor: {
        color: "#404349",
        paddingTop: "10px",
        wordBreak: "break-all"
    }
});
const styles = {
    containerProfile: {
        padding: "22px 25px 40px 24px",
    },
    containerCardContent: {
        paddingTop: "38px"
    }
}
const user = {
    avatar: "/static/images/avatars/avatar_6.png",
    jobTitle: "Senior Developer",
    userName: "test@iamconsulting.co.th",
    name: "Katarina Smith",
    email: "test@iamconsulting.co.th",
    agency: "I AM Consulting"
};
const ProfileHistorys = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { datas } = props;
    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }
    return (
        <>
            <Helmet>
                <title>PROFILE | PMS </title>
            </Helmet>
            <Card>
                <Box px={2} py={1} style={styles.containerProfile} sx={{ height: "100%" }}>
                    <CardContent className={classes.cardContentHeaderSize} sx={{ justifyContent: "flex-start", alignItems: "flex-start", padding: "0 0 21px 0 " }}>
                        <Grid container>
                            <Grid item lg={12} xs={12}>
                                <Typography fontSize={24} lineHeight={1} sx={{ fontWeight: "500" }}>
                                    {t(`label.profile`)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <Divider />
                    <CardContent className={classes.cardContentSize} sx={{ justifyContent: "flex-start", alignItems: "flex-start", padding: "38px 0 0 0", width: "100%" }}>
                        <Upload image={datas?.photo}></Upload>
                        <Box ml="20px" mt="20px" sx={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", width: "100%", flexWrap: "wrap", height: "calc(100% - 130px)" }}>
                            <Box sx={{ width: "100%", padding: "0 0 16px 0" }}>
                                <Typography fontSize={16} lineHeight={1} className={classes.titleColor}>
                                    {t(`label.username`)}
                                </Typography>
                                <Typography fontSize={18} lineHeight={1} className={classes.subTitleColor}>
                                    {formatData(datas?.username, "-")}
                                </Typography>
                            </Box>
                            <Box sx={{ width: "40%", padding: "16px 0" }}>
                                <Typography fontSize={16} lineHeight={1} className={classes.titleColor}>
                                    {t(`label.nameSurname`)}
                                </Typography>
                                <Typography fontSize={18} lineHeight={1} className={classes.subTitleColor}>
                                    {formatData(datas?.fullname, "-")}
                                </Typography>
                            </Box>
                            <Box sx={{ width: "60%", padding: "16px 0" }}>
                                <Typography fontSize={16} lineHeight={1} className={classes.titleColor}>
                                    {t(`label.email`)}
                                </Typography>
                                <Typography fontSize={18} lineHeight={1} className={classes.subTitleColor}>
                                    {formatData(datas?.email, "-")}
                                </Typography>
                            </Box>
                            <Box sx={{ width: "40%", padding: "16px 0", paddingRight: 5 }}>
                                <Typography fontSize={16} lineHeight={1} className={classes.titleColor}>
                                    {t(`label.position`)}
                                </Typography>
                                <Typography fontSize={18} lineHeight={1} className={classes.subTitleColor}>
                                    {formatData(datas?.position, "-")}
                                </Typography>
                            </Box>
                            <Box sx={{ width: "60%", padding: "16px 0" }}>
                                <Typography fontSize={16} lineHeight={1} className={classes.titleColor}>
                                    {t(`label.team`)}
                                </Typography>
                                <Typography fontSize={18} lineHeight={1} className={classes.subTitleColor}>
                                    {formatData(datas?.organization, "-")}
                                </Typography>
                            </Box>
                        </Box>
                    </CardContent>
                </Box>
            </Card>
        </>
    );
};
export default ProfileHistorys;
